import { LOCATION_CHANGE } from "connected-react-router";

const ADD_CARD = "clipboard/ADD_CARD";
const CLEAR_CLIPBOARD = "clipboard/CLEAR_CLIPBOARD";
const CLOSE_MOBILE_IMAGE = "clipboard/CLOSE_MOBILE_IMAGE";
const PROMOTE_TO_COMMANDER = "clipboard/PROMOTE_TO_COMMANDER";
const RECS = "clipboard/RECS";
const RECS_ERROR = "clipboard/RECS_ERROR";
const RECS_SUCCESS = "clipboard/RECS_SUCCESS";
const RESTORE_OLD_STORAGE = "clipboard/RESTORE_OLD_STORAGE";
const REMOVE_CARD = "clipboard/REMOVE_CARD";
const SET_VIEWER_IMAGE = "clipboard/SET_VIEWER_IMAGE";
const TOGGLE_DECKLIST = "clipboard/TOGGLE_DECKLIST";

const initialState = {
  cards: {},
  commander: "",
  isLoadingRecs: false,
  isOpen: false,
  mobileImageIsOpen: false,
  price: { cardkingdom: 0, tcgplayer: 0 },
  recs: [],
  viewerImage: "",
};

const clipboard = (state = initialState, action) => {
  const { ...currentCards } = state.cards;
  let price;
  switch (action.type) {
    case ADD_CARD:
      // eslint-disable-next-line no-case-declarations
      const newCards = { ...currentCards, [action.card.name]: action.card };
      price = getPrice(newCards);
      return {
        ...state,
        cards: newCards,
        price,
        viewerImage: action.card.image_uri,
      };
    case CLEAR_CLIPBOARD:
      return initialState;
    case CLOSE_MOBILE_IMAGE:
      return {
        ...state,
        mobileImageIsOpen: false,
      };
    case LOCATION_CHANGE:
      return {
        ...state,
        isOpen: false,
      };
    case PROMOTE_TO_COMMANDER:
      delete currentCards[action.card.name];
      if (!state.commander) {
        return {
          ...state,
          cards: currentCards,
          commander: action.card,
        };
      } else {
        currentCards[state.commander.name] = state.commander;
        return {
          ...state,
          cards: currentCards,
          commander: action.card,
        };
      }
    case RECS:
      return {
        ...state,
        isLoadingRecs: true,
      };
    case RECS_ERROR:
      return {
        ...state,
        isLoadingRecs: false,
      };
    case RECS_SUCCESS:
      return {
        ...state,
        isLoadingRecs: false,
        recs: action.recs,
      };
    case REMOVE_CARD:
      delete currentCards[action.name];
      price = getPrice(currentCards);
      return {
        ...state,
        cards: currentCards,
        commander: state.commander.name === action.name ? "" : state.commander,
        isOpen: Object.keys(currentCards).length === 0 ? false : state.isOpen,
        price,
      };
    case RESTORE_OLD_STORAGE:
      return {
        ...state,
        ...action.newState,
      };
    case SET_VIEWER_IMAGE:
      return {
        ...state,
        mobileImageIsOpen: true,
        viewerImage: action.card.image_uri,
      };
    case TOGGLE_DECKLIST:
      return {
        ...state,
        isOpen: !state.isOpen,
        recs: [],
      };
    default:
      return state;
  }
};

export const addCardToDecklist = ({
  color_identity,
  image_uris,
  is_partner,
  layout,
  legal_commander,
  name,
  names,
  prices,
  primary_type,
  sanitized_wo,
}) => (dispatch, getState) => {
  const { cards, commander } = getState().clipboard;

  if (is_partner) {
    const splitName = name.split(" // ");
    [0, 1].map((i) => {
      if (
        (commander === null || commander.name !== splitName[i]) &&
        !Object.keys(cards).includes(splitName[i])
      ) {
        dispatch({
          card: {
            color_identity: ["W", "U", "B", "R", "G"], // TODO separate out partner color id
            image_uri:
              image_uris[i].en || image_uris[i].startsWith("https://")
                ? image_uris[i]
                : "https://c1.scryfall.com/file/scryfall-cards/normal/front/" + image_uris[i],
            is_partner,
            layout,
            legal_commander,
            name: names[i],
            prices,
            primary_type,
            sanitized_wo,
          },
          type: ADD_CARD,
        });
      }
    });
  } else {
    if ((commander === null || commander.name !== name) && !Object.keys(cards).includes(name)) {
      dispatch({
        card: {
          color_identity,
          // eslint-disable-next-line no-prototype-builtins
          image_uri: image_uris[0].hasOwnProperty("normal") // /recs/ returns images with .normal :(
            ? image_uris[0].normal
            : image_uris[0].startsWith("https://")
            ? image_uris[0]
            : "https://c1.scryfall.com/file/scryfall-cards/normal/front/" + image_uris[0],
          is_partner,
          layout,
          legal_commander,
          name: ["meld", "modal_dfc", "transform"].includes(layout) ? names[0] : name,
          prices,
          primary_type,
          sanitized_wo,
        },
        type: ADD_CARD,
      });
    }
  }
  dispatch(updateRecs());
};

export const buyAtCardKingdom = () => (dispatch) => {
  const decklistParams = dispatch(getDecklistParams("\n"));
  const cardkingdomBaseUrl = "https://www.cardkingdom.com/builder";
  const edhrecPartnerParams =
    "partner=edhrec&utm_source=edhrec&utm_medium=clipboard&utm_campaign=edhrec";
  window.open(cardkingdomBaseUrl + "?" + edhrecPartnerParams + "&" + decklistParams, "_blank");
};

export const buyAtTCGPlayer = () => (dispatch) => {
  const decklistParams = dispatch(getDecklistParams("||"));
  const tcgplayerBaseUrl = "https://store.tcgplayer.com/massentry";
  const edhrecPartnerParams =
    "partner=EDHREC&utm_campaign=affiliate&utm_medium=clipboard&utm_source=EDHREC";
  window.open(tcgplayerBaseUrl + "?" + edhrecPartnerParams + "&" + decklistParams, "_blank");
};

export const checkOldStorage = () => (dispatch) => {
  let newState;
  if (localStorage.getItem("state") && JSON.parse(localStorage.getItem("state")).clipboard) {
    newState = JSON.parse(localStorage.getItem("state")).clipboard;
    localStorage.removeItem("state");
    if (localStorage.getItem("clipboardCards")) {
      newState.cards = JSON.parse(localStorage.getItem("clipboardCards"));
      localStorage.removeItem("clipboardCards");
    }
  }
  dispatch({ newState, type: RESTORE_OLD_STORAGE });
};

export const clearClipboard = () => (dispatch) => {
  dispatch({ type: CLEAR_CLIPBOARD });
};

export const closeMobileImage = () => (dispatch) => dispatch({ type: CLOSE_MOBILE_IMAGE });

export const copyClipboard = () => (dispatch) => {
  const myText = Object.keys(dispatch(getAllCards())).sort().join("\n");
  navigator.clipboard.writeText(myText);
};

export const decklistContains = (name) => (dispatch, getState) => {
  const { cards, commander } = getState().clipboard;
  // eslint-disable-next-line no-prototype-builtins
  return cards.hasOwnProperty(name) || name === commander.name;
};

export const exportToArchidekt = () => (dispatch) => {
  const decklistParams = dispatch(getDecklistParams("\n"));
  const baseUrl = "https://archidekt.com/cardImport";
  window.open(baseUrl + "?" + decklistParams, "_blank");
};

export const exportToMoxfield = () => (dispatch) => {
  const decklistParams = dispatch(getDecklistParams("\n"));
  const baseUrl = "https://www.moxfield.com/import";
  window.open(baseUrl + "?" + decklistParams, "_blank");
};

const getAllCards = () => (dispatch, getState) => {
  const { cards, commander } = getState().clipboard;
  if (commander !== "") cards[commander.name] = commander;
  return cards;
};

const getDecklistParams = (delimiter) => (dispatch) => {
  const cards = dispatch(getAllCards());
  const decklistString = Object.values(cards)
    .map((card) => {
      // eslint-disable-next-line no-prototype-builtins
      if (!card.name.includes(" // ") || (card.hasOwnProperty("layout") && card.layout === "split"))
        return card.name;
      return card.name.substring(0, card.name.indexOf(" // ")); // Remove transformed title text if it exists
    })
    .map((card) => "1 " + card)
    .join(delimiter);
  return "c=" + encodeURIComponent(decklistString);
};

const getPrice = (cards) => ({
  cardkingdom: Object.values(cards)
    .map(({ prices }) => prices.cardkingdom && prices.cardkingdom.price)
    .reduce((sum, x) => sum + x, 0),
  tcgplayer: Object.values(cards)
    .map(({ prices }) => prices.tcgplayer && prices.tcgplayer.price)
    .reduce((sum, x) => sum + x, 0),
});

export const promoteToCommander = (card) => (dispatch) => {
  dispatch({ card, type: PROMOTE_TO_COMMANDER });
  dispatch(updateRecs());
};

export const removeCardFromDecklist = (name) => (dispatch) => {
  dispatch({ name, type: REMOVE_CARD });
  dispatch(updateRecs());
};

export const setViewerImage = (card) => (dispatch) => dispatch({ card, type: SET_VIEWER_IMAGE });

export const toggleDecklist = () => (dispatch, getState) => {
  dispatch({ type: TOGGLE_DECKLIST });

  if (getState().clipboard.isOpen) {
    dispatch(updateRecs());
  }
};

export const clipboardButtonOnClick = (card) => (dispatch) => {
  const safeCardName = ["meld", "modal_dfc", "transform"].includes(card.layout)
    ? card.names[0]
    : card.name;

  if (dispatch(decklistContains(safeCardName))) {
    dispatch(removeCardFromDecklist(safeCardName));
  } else {
    dispatch(addCardToDecklist(card));
  }
};

export const updateRecs = () => async (dispatch, getState) => {
  const { cards, commander } = getState().clipboard;
  if (commander && Object.keys(cards).length > 1) {
    dispatch({ type: RECS });
    try {
      const res = await fetch("/api/recs/", {
        body: JSON.stringify({
          cards: Object.keys(cards),
          commanders: [commander.name],
          name: "",
        }),
        headers: {
          "Content-Type": "application/json",
        },
        method: "POST",
      });
      const json = await res.json();
      if (json.inRecs) {
        return dispatch({ recs: json.inRecs, type: RECS_SUCCESS });
      } else {
        return dispatch({ type: RECS_ERROR });
      }
    } catch (err) {
      console.error(err);
      dispatch({ type: RECS_ERROR });
    }
  }
};

export default clipboard;
